import React from "react";
import { graphql, PreloadedQuery, usePreloadedQuery } from "react-relay";
import { WidgetTodoSummary } from "widgets/src/WIdgetTodoSummary/WidgetTodoSummary";
import { WidgetTodoSummaryPreviewQuery } from "./__generated__/WidgetTodoSummaryPreviewQuery.graphql";

type Props = {
  query: PreloadedQuery<WidgetTodoSummaryPreviewQuery>;
};

export const WIDGET_TODO_SUMMARY_PREVIEW_QUERY = graphql`
  query WidgetTodoSummaryPreviewQuery(
    $storecastId: ID!
    $input: PreviewWidgetTodoSummaryInput!
  ) {
    dashboard(id: $storecastId) @required(action: THROW) {
      previewWidgetTodoSummary(input: $input) {
        ...WidgetTodoSummary_widgetTodoSummary
      }
    }
  }
`;

export function WATodoSummaryPreview(props: Props) {
  const data = usePreloadedQuery<WidgetTodoSummaryPreviewQuery>(
    WIDGET_TODO_SUMMARY_PREVIEW_QUERY,
    props.query
  );

  return (
    <WidgetTodoSummary
      widget={data.dashboard.previewWidgetTodoSummary}
      mode="IDLE"
      storecastId=""
      interactive={false}
    />
  );
}
